<template>
   <div class="dashboard-page">
      <div class="mt-3 pt-3">
         <nav class="mb-4" style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='white'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
            <ol class="breadcrumb" style="font-size:24px; line-height: 24px; font-weight:900;">
               <li class="breadcrumb-item" style="color:#435666;" aria-current="page">Dashboard</li>
            </ol>
         </nav>
      </div>

      <div class="content-wrapper mt-3">
         <!-- Option A1: Top KPI Summary Bar -->
         <div class="kpi-summary-bar">
            <!-- KPI 1: Upcoming Meetings -->
            <div class="kpi-card">
               <div class="kpi-icon-box kpi-teal">
                  <i class="fas fa-calendar-check"></i>
               </div>
               <div class="kpi-details">
                  <span class="kpi-label">Upcoming Meetings</span>
                  <div class="kpi-value-row">
                     <span class="kpi-value">{{ meetingsCount }}</span>
                     <span class="kpi-subtext">Scheduled BDM bookings</span>
                  </div>
               </div>
            </div>

            <!-- KPI 2: Pending Client Questions -->
            <div class="kpi-card">
               <div class="kpi-icon-box kpi-amber">
                  <i class="fas fa-comments"></i>
               </div>
               <div class="kpi-details">
                  <span class="kpi-label">Pending Client Questions</span>
                  <div class="kpi-value-row">
                     <span class="kpi-value">{{ questionsCount }}</span>
                     <span class="kpi-subtext">Awaiting proposal response</span>
                  </div>
               </div>
            </div>

            <!-- KPI 3: Pending Quick Orders -->
            <div class="kpi-card kpi-card-orders">
               <div class="kpi-icon-box kpi-teal">
                  <i class="fas fa-bolt"></i>
               </div>
               <div class="kpi-details">
                  <span class="kpi-label">Pending Quick Orders</span>
                  <div class="kpi-value-row">
                     <span class="kpi-value">{{ quickOrdersCounts.pendingCount }}</span>
                     <span class="kpi-subtext">Active order reminders</span>
                  </div>
               </div>
            </div>
         </div>

         <!-- Dashboard Widgets Stack -->
         <div class="dashboard-widgets-container">
            <quick-orders
               ref="quickOrdersWidget"
               @count-updated="onQuickOrdersCountUpdated"
            />
            <bdm-manager
               @count-updated="onMeetingsCountUpdated"
            />
            <client-questions
               @count-updated="onQuestionsCountUpdated"
            />
         </div>
      </div>
   </div>
</template>

<script>
import QuickOrders from '@/components/Dashboard/QuickOrders.vue';
import BdmManager from '@/components/Dashboard/BdmManager.vue';
import ClientQuestions from '@/components/Dashboard/ClientQuestions.vue';

export default {
  name: 'DashboardPage',
  components: {
    QuickOrders,
    BdmManager,
    ClientQuestions,
  },
  data() {
    return {
      meetingsCount: 0,
      questionsCount: 0,
      quickOrdersCounts: {
        pendingCount: 0,
        completedCount: 0,
        totalItems: 0,
      },
    };
  },
  methods: {
    onMeetingsCountUpdated(count) {
      this.meetingsCount = count || 0;
    },
    onQuestionsCountUpdated(count) {
      this.questionsCount = count || 0;
    },
    onQuickOrdersCountUpdated(counts) {
      if (counts && typeof counts === 'object') {
        this.quickOrdersCounts = {
          pendingCount: counts.pendingCount || 0,
          completedCount: counts.completedCount || 0,
          totalItems: counts.totalItems || 0,
        };
      }
    },
    triggerQuickOrder(orderType) {
      if (this.$refs.quickOrdersWidget && typeof this.$refs.quickOrdersWidget.openCreateModal === 'function') {
        this.$refs.quickOrdersWidget.openCreateModal(orderType);
      }
    },
  },
};
</script>

<style scoped>
.content-wrapper {
  position: relative;
  width: 100%;
  min-height: 80vh;
}

.kpi-summary-bar {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

.kpi-card {
  background-color: #ffffff;
  border-radius: 16px;
  border: 1px solid #e9ecef;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  padding: 20px 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  font-family: 'Roboto', sans-serif;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.kpi-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.07);
}

.kpi-icon-box {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  flex-shrink: 0;
}

.kpi-teal {
  background-color: #DAF3F9;
  color: #00A0C1;
}

.kpi-amber {
  background-color: #FFDEC3;
  color: #F3994D;
}

.kpi-details {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 0;
}

.kpi-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #5C768B;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 4px;
}

.kpi-value-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}

.kpi-value {
  font-size: 1.75rem;
  font-weight: 800;
  color: #435666;
  line-height: 1.1;
}

.kpi-subtext {
  font-size: 0.8rem;
  color: #5C768B;
}

.dashboard-widgets-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  align-items: flex-start;
  justify-content: flex-start;
}
</style>